import React, { useState, useEffect } from "react";
import "../../index.css";
import { Checkbox, Loader, Dropdown } from "semantic-ui-react";
import { axiosInstance } from "../../fetcher";
import { FaRegCopy } from "react-icons/fa";
import { APP_SETTINGS } from "../../env";

const style = {
  button: {
    backgroundColor: "#0D6EFD",
    color: "#fff",
    marginRight: "10px",
    border: "#140b39",
    marginLeft: "20px",
  },

  file: {
    width: "380%",
    height: "100%",
    color: "#808080",
    padding: "50px",
    border: "1px solid #D3D3D3",
  },
  dropDownL: {
    padding: "8px",
    fontSize: "14px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    backgroundColor: "#fff",
  },
  textBox1: {
    height: "200px",
  },
};

const TextTranslator = (props) => {
  const [translatedData, setTranslatedData] = useState("");
  const [targetLanguage, setTargetLanguage] = useState("en");
  const [sourceLanguage, setSourceLanguage] = useState("default");
  const [includeGlossary, setIncludeGlossary] = useState(false);
  const [glossaryState, setGlossaryState] = useState(false);
  const [glossaryMessageVisible, setGlossaryMessageVisible] = useState(false);
  const [textareaInputValue, setInputTextareaValue] = useState("");
  const [languageList, setLanguageList] = useState([]);
  const [loaderStatus, setLoaderStatus] = useState(false);
  const [checkBoxStatus, setCheckBoxStatus] = useState(false);
  const [sourceLanguageOptions, setSourceLanguageOptions] = useState([]);
  const [targetLanguageOptions, setTargetLanguageOptions] = useState([]);

  const [detectedTargetLanguage, setdetectedTargetLanguage] = useState(null);
  const [characterCount, setCharacterCount] = useState(0);
  const [engagementName, setEngagementName] = useState("");
  const [apiIdName, setApiIdName] = useState("");
  
  const currentDomain = window.location.hostname.split(".")[1];

  let endpointToUse;

  if (currentDomain === "azurewebsites") {
    endpointToUse = new URL(APP_SETTINGS.public_endpoint).origin;
  } else {
    endpointToUse = new URL(APP_SETTINGS.private_endpoint).origin;
  }
  const currentUrl = endpointToUse;

  useEffect(() => {
    fetchSupportedLanguages();
    checkparam();
  }, []);

  const checkparam = async () => {
    try {
      // const responseEngagementName = await axiosInstance.get(
      //   "/get_engagement_name"
      // );
      const responseEngagementName = await axiosInstance.post(
              "/engagements/get_engagements_name", { url: currentUrl }
            );
      
            
      
      setEngagementName(responseEngagementName.data.engagement_name);
      

      // const responseApiId = await axiosInstance.get("/get_api_id_text");

      setEngagementName(responseEngagementName.data.engagement_name);
      // setApiIdName(responseApiId.data);
      // setApiIdName(responseApiId.data.text_translate);
      // console.log(
      //   "OS Param value is - ",
      //   responseApiId.data,
      //   responseEngagementName.data
      // );
    } catch (error) {
      console.error("Error fetching supported languages:", error);
    }
  };

  const fetchSupportedLanguages = async () => {
    try {
      const response = await axiosInstance.get(
        "/glossary/get_supported_languages"
      );
      if (response.data.data.languages) {
        const defaultOption = [
          { key: "default", value: "default", text: "Auto-Detect" },
        ];

        const languageOptions = [
          ...response.data.data.languages
            .filter((ele) => ele.languageCode !== "auto")
            .sort((a, b) => a.languageName.localeCompare(b.languageName))
            .map((ele) => {
              return {
                key: ele.languageCode,
                value: ele.languageCode,
                text: ele.languageName,
              };
            }),
        ];

        const sourceLanguageOptions = defaultOption.concat(languageOptions);

        // console.log("options", sourceLanguageOptions);
        setSourceLanguageOptions(sourceLanguageOptions);
        setTargetLanguageOptions(sourceLanguageOptions);
        setLanguageList(response.data.languages);
        setIncludeGlossary(false);
        setSourceLanguage("default");
        setTargetLanguage("en");
      }
    } catch (error) {
      console.error("Error fetching supported languages:", error);
    }
  };

  const translateText = async () => {
    
    setLoaderStatus(true);
    setTranslatedData("");
    setGlossaryMessageVisible(false);
    const responseEngagementName = await axiosInstance.post(
              "/engagements/get_engagements_name", { url: currentUrl }
            );
      
            
      
    setEngagementName(responseEngagementName.data.engagement_name);
    
    const testTransalteRequest = {
      apiID: apiIdName, 
      // apiID: APP_SETTINGS.api_id,
      engagementName: responseEngagementName.data.engagement_name, // "ENDBS"
      text: textareaInputValue,
      targetLanguageCode: targetLanguage,
      sourceLanguageCode: sourceLanguage,
      includeGlossary: includeGlossary,
      hostnameURL: window.location.hostname,
    };
    try {
      const translatedLanguageResponse = await axiosInstance.post(
        `/translation/text_translate`,
        testTransalteRequest
      );
      const translatedData1 =
        translatedLanguageResponse.data.data.Translated_text;
      const detectedLanguage =
        translatedLanguageResponse.data.data.Detected_source_language;
      const detectedTarLanguage =
        translatedLanguageResponse.data.data.Detected_target_language;

      if (sourceLanguage == "default") {
        setSourceLanguage(detectedLanguage);
      }
      setTranslatedData(translatedData1);
      setdetectedTargetLanguage(detectedTarLanguage);
      setGlossaryState(includeGlossary);
      setGlossaryMessageVisible(true);
    } catch (e) {
      console.log(e);
    }
    setLoaderStatus(false);
    setIncludeGlossary(false);
  };

  const handleClearText = () => {
    const newText = "";
    setInputTextareaValue(newText);
    setTranslatedData(newText);
    setdetectedTargetLanguage("");
    setSourceLanguage("default");
    setTargetLanguage("en");
    setGlossaryMessageVisible(false);
    setIncludeGlossary(false);
  };

  const getGlossaryAvailability = async (
    sourceLanguageValue,
    targetLanguageValue
  ) => {
    // console.log("hit");
    try {
      if (
        targetLanguageValue !== "default" &&
        sourceLanguageValue !== "default"
      ) {
        const glossaryAvailabilityResponse = await axiosInstance.post(
          `/glossary/Glossary_availability`,
          {
            target_language_code: targetLanguageValue,
            source_language_code: sourceLanguageValue,
            engagementName: engagementName, // "ENDBS"
          }
        );
        console.log("glossaryAvailabilityResponse :", glossaryAvailabilityResponse);
        if (glossaryAvailabilityResponse.data.data == "True") {
          setCheckBoxStatus(false);
        } else {
          setCheckBoxStatus(true);
        }
      } else if (sourceLanguageValue === "default") {
        setCheckBoxStatus(false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div className="row">
        {/* Drowdown Selection Starts */}
        <div className="row mt-1">
          <div className="col">
            {/* Dropdown 1 for Detect Langauge */}
            <div className="row mt-1">
              <div className="col">
                <div>
                  <label
                    htmlFor="sourceLanguage"
                    style={{ marginRight: "10px" }}
                  >
                    <b>Source Language </b>
                  </label>
                  <Dropdown
                    search
                    fluid
                    floating
                    selection
                    options={sourceLanguageOptions}
                    value={sourceLanguage}
                    onChange={(e, data) => {
                      setSourceLanguage(data.value);
                      setIncludeGlossary(false);
                      getGlossaryAvailability(data.value, targetLanguage);
                    }}
                  />
                </div>
              </div>

              {/* Dropdown 2 for Target Langauge */}
              <div className="col">
                <div>
                  <label
                    htmlFor="targetLanguage"
                    style={{ marginRight: "10px" }}
                  >
                    <b>Target Language </b>
                  </label>
                  <Dropdown
                    search
                    fluid
                    floating
                    selection
                    options={targetLanguageOptions}
                    value={targetLanguage}
                    onChange={(e, data) => {
                      setTargetLanguage(data.value);
                      setIncludeGlossary(false);
                      getGlossaryAvailability(sourceLanguage, data.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Drowdown Selection Ends */}
        {/* Shows the Detection of the language starts */}

        {/* Shows the Detection of the language ends*/}

        <div className="row center-align mt-3" style={{ marginTop: "10px" }}>
          <div className="col center-align">
            <div style={{ position: "relative", maxWidth: "630px" }}>
              <textarea
                className="form-control"
                maxLength={50000}
                value={textareaInputValue}
                placeholder="Translation input"
                aria-label="default input example"
                style={{ height: "200px", maxWidth: "630px" }}
                spellCheck={true}
                lan={targetLanguage}
                onChange={(e) => {
                  setInputTextareaValue(e.target.value);
                  setCharacterCount(e.target.value.length);
                }}
              />
              {textareaInputValue && (
                <button
                  type="button"
                  className="btn btn-light"
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    zIndex: "2",
                  }}
                  onClick={handleClearText}
                  title="Clear Source Text"
                >
                  X
                </button>
              )}
            </div>
            <div style={{ textAlign: "right" }}>
              Character Count: {textareaInputValue.length}/50000
            </div>
          </div>

          <div className="col center-align">
            <textarea
              className="form-control"
              value={translatedData}
              placeholder="Translation output"
              aria-label="default input example"
              style={{ height: "200px", maxWidth: "630px" }}
              readOnly
            />
            <div>
              {glossaryMessageVisible ? (
              <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                <div
                  style={{
                    textAlign: "left",
                    display: "flex",
                    alignItems: "center",
                    color: "green",
                  }}
                >
                  <p style={{ color: "red", margin: 0 }}>*</p>
                  <div style={{ marginLeft: "5px" }}>
                    {glossaryState ? (
                      <div>Text translation is completed with glossary.</div>
                    ) : (
                      <div>Text translation is completed without glossary.</div>
                    )}
                  </div>
                </div>

                {/* Copy Icon Button */}
                <button
                  onClick={() => navigator.clipboard.writeText(translatedData)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "none",
                    fontSize: "18px",
                    marginLeft: "10px",
                  }}
                  title="Copy translated text"
                >
                  <FaRegCopy />
                </button>
              </div>
            ) : (
              <div></div>
            )}

            
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col">
            <div>
              <Checkbox
                checked={includeGlossary}
                disabled={checkBoxStatus}
                onChange={(e, data) => setIncludeGlossary(data.checked)}
                label={<label>Include Glossary</label>}
              />
              <button
                id="translatetextbtn"
                type="button"
                className="btn btn-primary custom-button"
                style={style.button}
                onClick={translateText}
              >
                Translate
              </button>
              <Loader inline active={loaderStatus} />
            </div>
          </div>
          <div className="col"></div>
        </div>
        <div className="row mt-1"></div>
      </div>
    </>
  );
};

export default TextTranslator;
